import { render, staticRenderFns } from "./downfile.vue?vue&type=template&id=810df8e0&scoped=true&"
import script from "./downfile.vue?vue&type=script&lang=js&"
export * from "./downfile.vue?vue&type=script&lang=js&"
import style0 from "./downfile.vue?vue&type=style&index=0&id=810df8e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810df8e0",
  null
  
)

export default component.exports